(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function () {
    const menu = document.querySelector('.header__left-menu');
    if (!menu) return;

    menu.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', function () {
        const currentDetails = this.parentElement;
        if (!currentDetails || currentDetails.tagName !== 'DETAILS') return;

        const parentList = currentDetails.closest('ul');
        if (!parentList) return;

        parentList.querySelectorAll(':scope > li > details.menu-opening').forEach((details) => {
          if (details !== currentDetails) {
            details.removeAttribute('open');
            details.querySelectorAll('details.menu-opening[open]').forEach((nested) => {
              nested.removeAttribute('open');
            });
          }
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (menu.contains(event.target)) return;

      menu.querySelectorAll('details.menu-opening[open]').forEach((details) => {
        details.removeAttribute('open');
      });
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const input = document.getElementById("HeaderSearchInput");
    const list = document.getElementById("HeaderAutocompleteList");
    if (!input || !list) return;

    input.addEventListener("input", function () {
      const query = this.value.trim();
      if (!query) {
        list.innerHTML = "";
        list.classList.add("hidden");
        return;
      }

      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`)
        .then(res => res.json())
        .then(data => {
          const products = data.resources.results.products || [];
          if (!products.length) {
            list.innerHTML = "";
            list.classList.add("hidden");
            return;
          }

          list.innerHTML = products.map(p => `
            <li class="autocomplete-item" data-href="${p.url}">
              <img 
                src="${p.image ? p.image : '//cdn.shopify.com/s/files/1/0000/0000/files/no-image.png'}" 
                alt="${p.title}"
              >
              <div class="item-info">
                <div class="item-title">${p.title}</div>
                <span class="item-stock ${p.available ? 'in-stock' : 'out-stock'}">
                  ${p.available ? 'In stock' : 'Out of stock'}
                </span>
              </div>
            </li>
          `).join("");

          list.classList.remove("hidden");
        })
        .catch(() => {
          list.innerHTML = "";
          list.classList.add("hidden");
        });
    });

    // Navigate when clicking a suggestion
    list.addEventListener("click", e => {
      const item = e.target.closest("li[data-href]");
      if (item) window.location.href = item.dataset.href;
    });

    // Hide dropdown when clicking outside
    document.addEventListener("click", e => {
      if (!e.target.closest("#HeaderSearchInput") && !e.target.closest("#HeaderAutocompleteList")) {
        list.classList.add("hidden");
      }
    });
  }); 


  } catch(e) { console.error(e); }
})();
})();
